module.exports = __webpack_public_path__ + "assets/img/退货.a9c7e1e5.jpg";